import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeMenu: '',
};

const app = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setActiveMenu: {
      reducer: (state, { payload }) => {
        state.activeMenu = payload;
      },
    },
  },
});

const { reducer, actions } = app;
export const { setActiveMenu } = actions;
export default reducer;
